export default "__VITE_ASSET__Bi20zm55__"